


































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

@Component({})
export default class MultiTab extends Vue {
  pages: any[] = [];
  fullPathList: string[] = [];
  activeKey = '';
  newTabIndex = 0;
  created() {
    this.pages.push(this.$route);
    this.fullPathList.push(this.$route.fullPath);
    this.selectedLastPath();
  }
  mounted() {}

  @Watch('$route')
  onRouteChanged(newVal: any) {
    this.activeKey = newVal.fullPath;
    if (this.fullPathList.indexOf(newVal.fullPath) < 0) {
      if (newVal.fullPath === '/') {
        this.fullPathList.unshift(newVal.fullPath);
        this.pages.unshift(newVal);
      } else {
        this.fullPathList.push(newVal.fullPath);
        this.pages.push(newVal);
      }
    }
  }
  @Watch('activeKey')
  activeKeyChanged(newPathKey: string) {
    this.$router.push({ path: newPathKey });
  }

  selectedLastPath() {
    this.activeKey = this.fullPathList[this.fullPathList.length - 1];
  }
  onEdit(targetKey: string, action: string) {
    if (action === 'remove') {
      this.remove(targetKey);
    } else {
      this.$error({ content: `未知功能 ${action}` });
    }
  }
  remove(targetKey: string) {
    const arr = this.pages.filter(page => page.fullPath === targetKey);
    if (arr.length === 0) {
      return;
    }
    const pageRemoved = arr[0];
    this.pages = this.pages.filter(page => page.fullPath !== targetKey);
    this.fullPathList = this.fullPathList.filter(path => path !== targetKey);
    // 判断当前标签是否关闭，若关闭则跳转到最后一个还存在的标签页
    if (!this.fullPathList.includes(this.activeKey)) {
      this.selectedLastPath();
    }
    // this.$message.info(`关闭了标签 ${pageRemoved.meta.title}`, 5);
  }

  /** muti tab close menu click */
  onMenuClose({ key, item, domEvent }: { key: string; item: any; domEvent: any }) {
    const path = domEvent.target.getAttribute('data-path');
    console.log('menu:', key, item, path);
    switch (key) {
      case 'close-right':
        this.closeRight(path);
        break;
      case 'close-left':
        this.closeLeft(path);
        break;
      case 'close-all':
        this.closeAll(path);
        break;
      default:
      case 'close-that':
        this.closeThat(path);
        break;
    }
  }
  closeThat(e: string) {
    this.remove(e);
  }
  closeLeft(e: string) {
    const currentIndex = this.fullPathList.indexOf(e);
    if (currentIndex > 0) {
      this.fullPathList.forEach((item, index) => {
        if (index < currentIndex) {
          this.remove(item);
        }
      });
    }
  }
  closeRight(e: string) {
    const currentIndex = this.fullPathList.indexOf(e);
    if (currentIndex < this.fullPathList.length - 1) {
      this.fullPathList.forEach((item, index) => {
        if (index > currentIndex) {
          this.remove(item);
        }
      });
    }
  }
  closeAll(e: string) {
    const currentIndex = this.fullPathList.indexOf(e);
    this.fullPathList.forEach((item, index) => {
      if (index !== currentIndex) {
        this.remove(item);
      }
    });
  }
}
